/**
 *
 */
export abstract class RemoteConfigLoader<C> {
    /**
     *
     */
    private cachedConfig?: C | null

    /**
     *
     */
    private cacheLoad?: Promise<C | null>

    /**
     *
     */
    private resetCount = 0

    /**
     *
     */
    private async getConfigUncached(): Promise<C | null> {
        let newConfig: C | null = null
        const rc = this.resetCount
        try {
            const response = await this.fetch(this.url)
            if(!response.ok) {
                throw new Error(`Could not load config: ${response.status} ${response.statusText}`)
            }
            newConfig = await response.json()
        } catch (error) {
            console.error(error)
            newConfig = null
        }
        if(rc == this.resetCount) {
            this.cachedConfig = newConfig
        }
        return newConfig
    }

    /**
     *
     */
    protected abstract readonly url: string

    /**
     * For testing
     */
    public readonly fetch =
        (input: RequestInfo | URL, init?: RequestInit | undefined) => fetch(input, init)

    /**
     * @returns
     */
    public async getConfig(): Promise<C | null> {
        if (this.cacheLoad) {
            return this.cacheLoad
        } else if (this.cachedConfig === undefined) {
            this.cacheLoad = this.getConfigUncached()
            return this.cacheLoad
        } else {
            return this.cachedConfig
        }
    }

    /**
     * For testing
     */
    public reset() {
        this.cacheLoad = undefined
        this.cachedConfig = undefined
        this.resetCount++
    }
}